import { TokenType, CELL_DISPLAY_SETTINGS } from "@ubisolutions/base";

export const cellDisplaySettingsProvider = {
    provide: CELL_DISPLAY_SETTINGS,
    useValue: {
        animateInputChanges: true,
        animateComponentChanges: true,
    } satisfies TokenType<typeof CELL_DISPLAY_SETTINGS>,
};
